import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { SPACE } from '../../../../Theme';
import { Text, Box, Flex } from '../../../../Base';
import { QuestionView } from '../Question';
import { EXAM_TYPE, EXAM_MODE, ChoicePropType } from '../constant';

const QuestionHeader = ({ currentQuestionNumber, t }) => (
  <Flex justifyContent="space-between" alignItems="center" pt={SPACE.md}>
    {currentQuestionNumber !== null && currentQuestionNumber !== undefined && (
      <Text
        textStyle={'heading5'}
        fontWeight="medium"
        fontFamily="content"
        color="quizQuestionTitle"
      >
        {t('EXAM.HEADER.QUESTION_NO', { questionNo: currentQuestionNumber })}
      </Text>
    )}
  </Flex>
);

const QuestionBlock = ({
  question,
  onAnswer,
  currentQuestionNumber,
  mode,
  isFillInTheBlankQuiz,
  renderFooterBlock,
  userAnswer,
  isCorrect,
  isShowSolution,
  t,
}) => {
  return (
    <Fragment>
      <Box mb={SPACE.md}>
        <QuestionHeader
          currentQuestionNumber={currentQuestionNumber}
          questionType={question.type}
          isCorrect={question.isCorrect}
          t={t}
        />
      </Box>
      <Box
        bg="white"
        style={{
          borderRadius: 12,
        }}
      >
        <QuestionView
          question={question}
          onAnswer={onAnswer}
          mode={mode}
          isFillInTheBlankQuiz={isFillInTheBlankQuiz}
          renderFooterBlock={renderFooterBlock}
          userAnswer={userAnswer}
          isCorrect={isCorrect}
          isShowSolution={isShowSolution}
        />
      </Box>
    </Fragment>
  );
};

QuestionBlock.propTypes = {
  question: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(EXAM_TYPE)).isRequired,
    title: PropTypes.string.isRequired,
    choices: PropTypes.arrayOf(ChoicePropType),
    isCorrect: PropTypes.bool,
  }),
  onAnswer: PropTypes.func,
  currentQuestionNumber: PropTypes.number,
  mode: PropTypes.oneOf(Object.values(EXAM_MODE)),
  isFillInTheBlankQuiz: PropTypes.bool,
  isCorrect: PropTypes.bool,
  isShowSolution: PropTypes.bool,
  renderFooterBlock: PropTypes.func,
  userAnswer: PropTypes.string,
  t: PropTypes.any,
};

QuestionBlock.defaultProps = {
  mode: EXAM_MODE.ANSWERING,
  isFillInTheBlankQuiz: () => {},
};

export default withTranslation('exams')(QuestionBlock);
